module.exports = __webpack_public_path__ + "assets/fonts/Georgia.0355b6ac.ttf";